import { FunctionComponent } from 'react';
import { ConfigContext } from './ConfigContext';
import { IConfig } from './IConfig';

interface IConfigProps {
	config: IConfig;
}

export const withConfig = <P extends {}>(
	Component: FunctionComponent<P & IConfigProps>,
) =>
	function (props: P) {
		return (
			<ConfigContext.Consumer>
				{(config) => <Component config={config} {...props} />}
			</ConfigContext.Consumer>
		);
	};
